import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef28446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Lap")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Pause")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_6 = { key: 0 }

import useTracker from '../composables/useTracker'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  name,
  clockStatus,
  elapsedSplitTime,
  elapsedFullTime,
  disabled,
  getLaps,
  handleStart,
  handlePause,
  handleLap,
  handleSave
} = useTracker()

return (_ctx: any,_cache: any) => {
  const _component_app_textfield = _resolveComponent("app-textfield")!
  const _component_app_btn = _resolveComponent("app-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_textfield, {
        modelValue: _unref(name),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_unref(elapsedFullTime)), 1),
        _createElementVNode("h5", null, _toDisplayString(_unref(elapsedSplitTime)), 1)
      ]),
      _createVNode(_component_app_btn, {
        disabled: _unref(disabled).start(),
        onClick: _unref(handleStart)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(clockStatus) === 'paused' ? 'Resume' : 'Start'), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_app_btn, {
        disabled: _unref(disabled).paused(),
        onClick: _unref(handleLap)
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_app_btn, {
        disabled: _unref(disabled).paused(),
        onClick: _unref(handlePause)
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_app_btn, {
        disabled: _unref(disabled).stopped(),
        onClick: _unref(handleSave)
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    (_unref(getLaps)().length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getLaps)(), (lap, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key * 12589
            }, _toDisplayString(lap), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})